import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useEffect } from 'react';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
    //   maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, selectedOptions, theme) {
  return {
    fontWeight:
    selectedOptions.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export default function MultipleSelect(props) {
  const theme = useTheme();
  const [selectedOptions, setSelectedOptions] = React.useState([]);

  useEffect(() => {
    
  }, [selectedOptions]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedOptions(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
    props.onMultiSelect(value);
  };

  return (
      <FormControl 
        error={props.error}
        sx={props.fullWidth ? { width: '100%', m: 0, textAlign: 'left' } : { m: 1, width: 350 }} 
        fullWidth={props.fullWidth}
      >
        <InputLabel id="demo-multiple-name-label">{props.label}</InputLabel>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          multiple
          size={props.size || "medium"}
          value={props.savedOptions.length===0 ? selectedOptions : props.savedOptions}  //show selected months if stored in DB.
          onChange={handleChange}
          input={<OutlinedInput label={props.label} />}
          MenuProps={MenuProps}
        >
          {props.options.map((option) => (
            <MenuItem
              key={option.id}
              value={option.title}
              style={getStyles(option.title, selectedOptions, theme)}
            >
              {option.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
  );
}


// MUI multiselect by default adds comma along with items as value of Select.